import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NameIdPair } from '../interfaces/name-id-pair.interface';
import { LinkTransferPreview } from '../interfaces/link-transfer-preview.interface';
import { LinkTransferRequestModel } from '../interfaces/link-transfer-request-model.interface';

@Injectable({
	providedIn: 'root',
})
export class LinkTransferService {
	url: string = 'linkTransfer';

	constructor(private http: HttpClient) {}

	public getSelectableAL2Users() {
		return this.http.get<NameIdPair[]>(`${this.url}/GetSelectableAL2Users`);
	}

	public getAL2UserDomainPreview(userId: number) {
		return this.http.get<LinkTransferPreview[]>(`${this.url}/GetAL2UserDomainPreview/${userId}`);
	}

	public getSelectableCompanies() {
		return this.http.get<NameIdPair[]>(`${this.url}/GetSelectableCompanies`);
	}

	public transferLinks(model: LinkTransferRequestModel) {
		return this.http.post<any[]>(`${this.url}/TransferLinks`, model);
	}

	public updatePurchaseOrderCache() {
		return this.http.post<any[]>(`${this.url}/UpdatePurchaseOrderCache`, {});
	  }
}
